import React from 'react';
import PropTypes from 'prop-types';

function Star03({ fill, className }) {
  return (
    <svg
      className={className}
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 19"
    >
      <polygon
        points="3.82 19 6 18 6 6.06 0 7.26 4.61 12.25 3.82 19"
        fill={fill}
      />
    </svg>
  );
}

Star03.propTypes = {
  fill: PropTypes.string,
  className: PropTypes.string,
};

Star03.defaultProps = {
  fill: undefined,
  className: '',
};

export default Star03;
